import React from "react";
import { IDatabases, IDataCenter, ISystemConfig } from "../../vm";
import * as yup from "yup";
import CustomDrawer from "../common/CustomDrawer";
import { Formik } from "formik";
import {
  DefaultButton,
  IBasePickerSuggestionsProps,
  IStackTokens,
  ITag,
  PrimaryButton,
  Stack,
  TagPicker,
  Toggle,
} from "office-ui-fabric-react";
import { CustomTextField } from "../common/Library";
import {
  getMorPdus,
  searchQuadrantsOfDC,
} from "../../services/datacenter/DatacenterService";
import { updateSystemConfig } from "../../services/system-config/SystemConfigService";
import { ToastContext } from "../common/ToastProvider";
import NoDataPage from "../common/NoDataPage";
import NoDataTile from "../common/NoDataTile";
import { Loading } from "../../services/Loading";

const tablesSchema = yup.object().shape({
  floorName: yup.string().optional(),
  dedicatedName: yup.string().optional(),
  rackwiseName: yup.string().optional(),
  pduName: yup.string().optional(),
  tableName: yup.string().optional(),
  quadrantName: yup.string().optional(),
});

const databasesSchema = yup.object().shape({
  name: yup.string().required("required"),
  tableLevel: yup.string().optional(),
  datacenterName: yup.string().optional(),
  datacenterId: yup.string().optional(),
  tables: yup.array().of(tablesSchema),
});

export interface ManageDatabaseDialogEditProps {
  systemConfig: ISystemConfig;
  databases: IDatabases[];
  data?: IDatabases;
  dataCenterList: ITag[];
  allDataCenter: IDataCenter[];
  handleEditDialogClose: any;
  isOnEdit: boolean;
  handleLoading: any;
  handleDialogClose: any;
  index: number;
}

const ManageDatabaseDialogEdit: React.FC<ManageDatabaseDialogEditProps> = ({
  systemConfig,
  data,
  handleEditDialogClose,
  isOnEdit,
  databases,
  dataCenterList,
  allDataCenter,
  handleLoading,
  handleDialogClose,
  index,
}) => {
  //state
  const [state, setState] = React.useState({
    databaseObj: {
      name: "",
      datacenterId: "",
      tableLevel: "floor",
      tables: [],
      ...data,
    },
    selectedDatacenters: [],
    // pduList: [],
    isDataloaded: false,
    isLoading: false,
  } as {
    databaseObj: IDatabases;
    selectedDatacenters: Array<{ key: string; name: string }>;
    // pduList: any;
    isDataloaded: boolean;
    isLoading: boolean;
  });

  const [tableLabel, setTableLebel] = React.useState("floor");

  // customs hooks
  const { showToast } = React.useContext(ToastContext);

  const closeAddDialog = (data?: IDatabases) => {
    handleEditDialogClose(data);
  };

  const addUpdateValue = (data?: ISystemConfig) => {
    handleDialogClose(data);
  };

  const wrapStackTokens: IStackTokens = { childrenGap: 16 };

  React.useEffect(() => {
    if (data) {
      console.log("datafrom get", data);
      const asyncFunc = async () => {
        // await getPowerComponentList();
        if (data.tableLevel === "quadrant") {
          setTableLebel("quadrant");
          await getQuadrantDetails(data.datacenterId);
        }
      };
      asyncFunc();
    }
  }, []);

  const getQuadrantDetails = async (datacenterId: string) => {
    setState({ ...state, isDataloaded: false, isLoading: true });
    const quadrantResp = await searchQuadrantsOfDC(datacenterId);

    if (quadrantResp?.success) {
      const dc = allDataCenter.find((d) => d._id === datacenterId);
      const floorDict = dc
        ? dc.floors.reduce((acc, d) => {
            let item = dc?.buildings.find((i: any) => i._id === d.buildingId);
            acc[d._id] = {
              name: item.name + "-" + d.name,
            };
            return acc;
          }, {})
        : {};
      const quadrantDict = quadrantResp.data.reduce((acc: any, d) => {
        const floor = floorDict[d.floorId];
        acc[d._id as string] = (floor ? floor.name : "") + "-" + d.quadrant;
        return acc;
      }, {});
      let tables: any = data?.tables.map((d) => {
        return {
          ...d,
          quadrantName: quadrantDict[d.quadrantId as any],
        };
      });
      setState({
        ...state,
        databaseObj: { ...state.databaseObj, tables },
        isDataloaded: true,
        isLoading: false,
      });
    } else {
      setState({
        ...state,
        isLoading: false,
        isDataloaded: false,
      });
    }
  };

  // const getPowerComponentList = async () => {
  //   setState({ ...state, isDataloaded: false, isLoading: true });
  //   let result = await getMorPdus({
  //     datacenterId: data?.datacenterId as string,
  //     types: ['pdu'],
  //   });

  //   console.log(result?.data);
  //   let tables: any = [];
  //   if (result?.success) {
  //     tables = data?.tables.map((ele) => {
  //       let pdusData = result?.data.filter(
  //         (pdu) => pdu.floorId === ele.floorId
  //       );
  //       let pduIndex = pdusData.findIndex((e) => e._id === ele.pduId);
  //       return {
  //         ...ele,
  //         pduName: pdusData[pduIndex]?.name || '',
  //         index: pduIndex,
  //         length: pdusData.length,
  //       };
  //     });
  //     setState({
  //       ...state,
  //       databaseObj: { ...state.databaseObj, tables },
  //       isDataloaded: true,
  //       isLoading: false,
  //     });
  //   } else {
  //     setState({
  //       ...state,
  //       isLoading: false,
  //       isDataloaded: false,
  //     });
  //   }
  // };

  const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No datacenters found",
  };

  const filterSuggestedTags = (filterText: string, tagList: ITag[]): ITag[] => {
    let database = [...databases];
    let allDataCenterList = [...dataCenterList];

    database.map((item) => {
      return (allDataCenterList = allDataCenterList.filter(
        (ele) => ele.key !== item.datacenterId
      ));
    });

    return filterText
      ? allDataCenterList.filter(
          (tag) =>
            tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 &&
            !listContainsTagList(tag, tagList)
        )
      : [];
  };

  const showAllTags = (selectedItems?: ITag[] | undefined) => {
    let database = [...databases];
    let allDataCenterList = [...dataCenterList];

    database.map((item) => {
      return (allDataCenterList = allDataCenterList.filter(
        (ele) => ele.key !== item.datacenterId
      ));
    });

    console.log(allDataCenterList);
    return removeDuplicates(allDataCenterList, selectedItems);
  };

  function removeDuplicates(tagList: ITag[], tags?: ITag[]) {
    return tagList.filter((tag) => !listContainsTagList(tag, tags));
  }

  const listContainsTagList = (tag: ITag, tagList?: ITag[]) => {
    if (!tagList || !tagList.length || tagList.length === 0) {
      return false;
    }
    return tagList.some((compareTag) => compareTag.key === tag.key);
  };

  return (
    <React.Fragment>
      <CustomDrawer
        title={
          data
            ? isOnEdit
              ? "Update Database Configuration"
              : "View Database Configuration"
            : "Add Database Configuration"
        }
        handelOpen={true}
        onClose={() => closeAddDialog()}
      >
        {systemConfig.systemType === "delta" && state.isLoading && <Loading />}
        {!data && systemConfig.systemType === "schneider" && (
          <React.Fragment>
            <Formik
              enableReinitialize
              initialValues={state.databaseObj}
              validationSchema={databasesSchema}
              onSubmit={async (values: any, { setSubmitting }) => {
                let obj = { ...values };
                obj.tableLevel = tableLabel;

                let data: ISystemConfig = { ...systemConfig };
                data.databases.push(obj);

                handleLoading();
                let result = await updateSystemConfig(data);
                handleLoading();

                if (result?.success) {
                  closeAddDialog(obj);
                  addUpdateValue(result.data);
                } else {
                  showToast(
                    result?.message ||
                      "Error while adding database configuration",
                    "error"
                  );
                }
                setState({
                  ...state,
                  databaseObj: {
                    name: "",
                    datacenterId: "",
                    datacenterName: "",
                    tables: [],
                  },
                  selectedDatacenters: [],
                });
                setSubmitting(false);
              }}
            >
              {({ handleSubmit, setFieldValue, values }) => (
                <form onSubmit={handleSubmit}>
                  <div className="ms-Grid pt-8">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-xs12 ms-sm6 custom-picker">
                        <TagPicker
                          removeButtonAriaLabel="Remove"
                          itemLimit={1}
                          selectedItems={state.selectedDatacenters}
                          onResolveSuggestions={filterSuggestedTags as any}
                          pickerSuggestionsProps={pickerSuggestionsProps}
                          onEmptyResolveSuggestions={showAllTags}
                          inputProps={{
                            placeholder: "Search a particular datacenter",
                          }}
                          // onDismiss={OnClose}
                          onChange={(items: any) => {
                            let databaseObj = { ...state.databaseObj };
                            items.forEach((ele: any) => {
                              databaseObj.datacenterId = ele.key;
                              databaseObj.datacenterName = ele.name;
                            });
                            let allDataCenters = [...allDataCenter];
                            if (items[0]) {
                              let reqDataCenter = allDataCenters.find(
                                (ele) => ele._id === items[0].key
                              );

                              let tables: any = [];
                              reqDataCenter?.floors.forEach((ele) => {
                                let item = reqDataCenter?.buildings.find(
                                  (i: any) => i._id === ele.buildingId
                                );
                                tables.push({
                                  floorName: item.name + " - " + ele.name,
                                  floorId: ele._id,
                                  dedicatedName: "",
                                  rackwiseName: "",
                                });
                              });
                              databaseObj.tables = tables;
                            }
                            setState({
                              ...state,
                              databaseObj,
                              selectedDatacenters: items,
                            });
                            console.log("databaseObj", databaseObj);
                          }}
                        />
                      </div>
                      <div className="ms-Grid-col ms-xs12 ms-sm6">
                        <CustomTextField
                          name={"name"}
                          placeholder={"Database's Name"}
                          disabled={state.databaseObj.datacenterId === ""}
                        />
                      </div>
                      <div className="ms-Grid-col ms-xs12 ms-sm6">
                        <Toggle
                          defaultChecked={values.tableLevel === "quadrant"}
                          onText="Is at Quadrant Level?"
                          offText="Is at Quadrant Level?"
                          disabled={state.selectedDatacenters.length === 0}
                          onChange={async (e, v) => {
                            setFieldValue(
                              "tableLevel",
                              v === true ? "quadrant" : "floor"
                            );
                            setTableLebel(v === true ? "quadrant" : "floor");
                            if (v === true) {
                              setState({
                                ...state,
                                isDataloaded: false,
                                isLoading: true,
                              });
                              const sDc: any = state.selectedDatacenters[0];
                              const quadrantResp = await searchQuadrantsOfDC(
                                sDc.key
                              );

                              if (quadrantResp?.success) {
                                const dc = allDataCenter.find(
                                  (d) => d._id === sDc.key
                                );
                                const floorDict = dc
                                  ? dc.floors.reduce((acc, d) => {
                                      let item = dc?.buildings.find(
                                        (i: any) => i._id === d.buildingId
                                      );
                                      acc[d._id] = {
                                        name: item.name + "-" + d.name,
                                      };
                                      return acc;
                                    }, {})
                                  : {};
                                const tables = quadrantResp.data.map((d) => {
                                  const floor = floorDict[d.floorId];
                                  return {
                                    quadrantId: d._id,
                                    quadrantName:
                                      (floor ? floor.name : "") +
                                      "-" +
                                      d.quadrant,
                                    dedicatedName: "",
                                    rackwiseName: "",
                                  };
                                });
                                console.log("tables", tables);
                                setState({
                                  ...state,
                                  databaseObj: { ...state.databaseObj, tables },
                                  isDataloaded: true,
                                  isLoading: false,
                                });
                              } else {
                                setState({
                                  ...state,
                                  isDataloaded: true,
                                  isLoading: false,
                                });
                              }
                            } else {
                              let databaseObj = { ...state.databaseObj };
                              let allDataCenters = [...allDataCenter];
                              let reqDataCenter = allDataCenters.find(
                                (ele) =>
                                  ele._id === state.selectedDatacenters[0].key
                              );

                              let tables: any = [];
                              reqDataCenter?.floors.forEach((ele) => {
                                let item = reqDataCenter?.buildings.find(
                                  (i: any) => i._id === ele.buildingId
                                );
                                tables.push({
                                  floorName: item.name + " - " + ele.name,
                                  floorId: ele._id,
                                  dedicatedName: "",
                                  rackwiseName: "",
                                });
                              });
                              databaseObj.tables = tables;
                              setState({
                                ...state,
                                databaseObj,
                              });
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm12">
                        {state.databaseObj.datacenterId !== "" && (
                          <div className="office-table">
                            <table className="ms-Table w-100">
                              <thead className="html-table-thead">
                                <tr>
                                  <th>
                                    {tableLabel === "quadrant"
                                      ? "Quadrant Name"
                                      : "Floor Name"}
                                  </th>
                                  <th>Dedicated Table Name</th>
                                  <th>Rackwise Table Name</th>
                                </tr>
                              </thead>
                              <tbody>
                                {state.databaseObj.tables.length > 0 ? (
                                  state.databaseObj.tables.map(
                                    (ele: any, index: number) => {
                                      return (
                                        <tr key={index}>
                                          <td>
                                            {tableLabel === "quadrant"
                                              ? ele.quadrantName
                                              : ele.floorName}
                                          </td>
                                          <td>
                                            <CustomTextField
                                              name={`tables[${index}].dedicatedName`}
                                            />
                                          </td>
                                          <td>
                                            <CustomTextField
                                              name={`tables[${index}].rackwiseName`}
                                            />
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan={3} align="center">
                                      <br />
                                      No Data Found
                                      <br />
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <Stack
                    horizontal
                    horizontalAlign="end"
                    wrap
                    tokens={wrapStackTokens}
                    // className="pt-8"
                  >
                    <DefaultButton
                      text="Cancel"
                      onClick={() => closeAddDialog()}
                      className="borderless-btn"
                    />
                    <PrimaryButton type="submit" text="Add" />
                  </Stack>
                </form>
              )}
            </Formik>
          </React.Fragment>
        )}
        {data && systemConfig.systemType === "schneider" && (
          <React.Fragment>
            <Formik
              enableReinitialize
              initialValues={state.databaseObj}
              validationSchema={databasesSchema}
              onSubmit={async (values: any, { setSubmitting }) => {
                let obj = { ...values };
                obj.tableLevel = tableLabel;
                let data: ISystemConfig = { ...systemConfig };
                data.databases[index] = obj;

                handleLoading();
                let result = await updateSystemConfig(data);
                handleLoading();

                if (result?.success) {
                  closeAddDialog(obj);
                  addUpdateValue(result.data);
                } else {
                  showToast(
                    result?.message ||
                      "Error while updating database configuration",
                    "error"
                  );
                }
                setState({
                  ...state,
                  databaseObj: {
                    datacenterName: "",
                    datacenterId: "",
                    name: "",
                    tables: [],
                  },
                  //   selectedDatacenters: [],
                });
                setSubmitting(false);
              }}
            >
              {({ handleSubmit, values }) => (
                <form onSubmit={handleSubmit}>
                  <div className="ms-Grid">
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-xs12 ms-sm6">
                        <CustomTextField
                          name={"name"}
                          placeholder={"Database's Name"}
                          disabled={!isOnEdit}
                        />
                      </div>
                      <div className="ms-Grid-col ms-xs12 ms-sm6">
                        <CustomTextField name={"datacenterName"} disabled />
                      </div>
                    </div>
                    <div className="ms-Grid-row">
                      <div className="ms-Grid-col ms-sm12">
                        <div className="office-table">
                          <table className="ms-Table w-100">
                            <thead className="html-table-thead">
                              <tr>
                                <th>
                                  {tableLabel === "quadrant"
                                    ? "Quadrant Name"
                                    : "Floor Name"}
                                </th>
                                <th>Dedicated Table Name</th>
                                <th>Rackwise Table Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              {state.databaseObj.tables.map(
                                (ele: any, indx: number) => {
                                  return (
                                    <tr key={indx}>
                                      <td>
                                        {tableLabel === "quadrant"
                                          ? ele.quadrantName
                                          : ele.floorName}
                                      </td>
                                      <td>
                                        <CustomTextField
                                          name={`tables[${indx}].dedicatedName`}
                                          disabled={!isOnEdit}
                                        />
                                      </td>
                                      <td>
                                        <CustomTextField
                                          name={`tables[${indx}].rackwiseName`}
                                          disabled={!isOnEdit}
                                        />
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Stack
                    horizontal
                    wrap
                    tokens={wrapStackTokens}
                    horizontalAlign="end"
                    className="pt-8"
                  >
                    <DefaultButton
                      text="Cancel"
                      onClick={() => closeAddDialog()}
                      className="borderless-btn"
                    />
                    {isOnEdit && <PrimaryButton text="Update" type="submit" />}
                  </Stack>
                </form>
              )}
            </Formik>
          </React.Fragment>
        )}

        {/* {!data && systemConfig.systemType === 'delta' && (
          <React.Fragment>
            <Formik
              enableReinitialize
              initialValues={state.databaseObj}
              validationSchema={databasesSchema}
              onSubmit={async (values: any, { setSubmitting }) => {
                let obj = { ...values };

                let data: ISystemConfig = { ...systemConfig };
                data.databases.push(obj);

                handleLoading();
                let result = await updateSystemConfig(data);
                closeAddDialog(obj);
                handleLoading();

                if (result?.success) {
                  closeAddDialog(obj);
                  addUpdateValue(result.data);
                } else {
                  showToast(
                    result?.message ||
                      'Error while adding database configuration',
                    'error'
                  );
                }

                setState({
                  ...state,
                  databaseObj: {
                    name: '',
                    datacenterId: '',
                    datacenterName: '',
                    tables: [],
                  },
                  selectedDatacenters: [],
                });
                setSubmitting(false);
              }}>
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div className='ms-Grid pt-8'>
                    <div className='ms-Grid-row'>
                      <div className='ms-Grid-col ms-xs12 ms-sm6'>
                        <TagPicker
                          removeButtonAriaLabel='Remove'
                          itemLimit={1}
                          selectedItems={state.selectedDatacenters}
                          onResolveSuggestions={filterSuggestedTags as any}
                          pickerSuggestionsProps={pickerSuggestionsProps}
                          onEmptyResolveSuggestions={showAllTags}
                          inputProps={{
                            placeholder: 'Search a particular datacenter',
                          }}
                          // onDismiss={OnClose}
                          onChange={async (items: any) => {
                            let databaseObj = { ...state.databaseObj };
                            items.forEach((ele: any) => {
                              databaseObj.datacenterId = ele.key;
                              databaseObj.datacenterName = ele.name;
                            });
                            let allDataCenters = [...allDataCenter];
                            let result: any;
                            if (items[0]) {
                              let reqDataCenter = allDataCenters.find(
                                (ele) => ele._id === items[0].key
                              );
                              setState({ ...state, isLoading: true });
                              result = await getMorPdus({
                                datacenterId: items[0].key,
                                types: ['pdu'],
                              });

                              let tables: any = [];

                              reqDataCenter?.floors.forEach((floor) => {
                                let item = reqDataCenter?.buildings.find(
                                  (i) => i._id === floor.buildingId
                                );
                                let pduData: any = [];
                                result?.data.forEach((i: any) => {
                                  if (i.floorId === floor._id) {
                                    pduData.push(i);
                                  }
                                });
                                pduData.forEach(
                                  (pduItem: any, pduIndex: number) => {
                                    tables.push({
                                      floorName: item.name + ' - ' + floor.name,

                                      floorId: floor._id,
                                      pduId: pduItem._id,
                                      pduName: pduItem.name,
                                      tableName: '',
                                      length: pduData.length,
                                      index: pduIndex,
                                      // rackwiseName: "",
                                    });
                                  }
                                );
                              });

                              console.log('tables', tables);

                              databaseObj.tables = tables;
                            }
                            console.log(result?.data);

                            setState({
                              ...state,
                              databaseObj,
                              selectedDatacenters: items,
                              isLoading: false,
                              // pduList: result?.data || [],
                            });
                            console.log('databaseObj', databaseObj);
                          }}
                        />
                      </div>
                      <div className='ms-Grid-col ms-xs12 ms-sm6'>
                        <CustomTextField
                          name={'name'}
                          placeholder={"Database's Name"}
                          disabled={state.databaseObj.datacenterId === ''}
                        />
                      </div>
                    </div>
                    <div className='ms-Grid-row'>
                      <div className='ms-Grid-col ms-sm12'>
                        {state.databaseObj.datacenterId !== '' && (
                          <div className='office-table'>
                            <table className='ms-Table w-100'>
                              <thead>
                                <tr>
                                  <th>Floor Name</th>
                                  <th>PDU Name</th>
                                  <th>Table Name</th>
                                </tr>
                              </thead>
                              <tbody>
                                {state.databaseObj.tables.length > 0 ? (
                                  state.databaseObj.tables.map(
                                    (ele: any, index: number) => {
                                      return (
                                        <tr key={index}>
                                          {ele.index === 0 && (
                                            <td rowSpan={ele.length}>
                                              {ele.floorName}
                                            </td>
                                          )}
                                          <td>{ele.pduName}</td>
                                          <td>
                                            <CustomTextField
                                              name={`tables[${index}].tableName`}
                                            />
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )
                                ) : (
                                  <tr>
                                    <td colSpan={3} align='center'>
                                      <br />
                                      No Data Found
                                      <br />
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <Stack
                    horizontal
                    horizontalAlign='end'
                    wrap
                    tokens={wrapStackTokens}
                    // className="pt-8"
                  >
                    <DefaultButton
                      text='Cancel'
                      onClick={() => closeAddDialog()}
                    />
                    <PrimaryButton type='submit' text='Add' />
                  </Stack>
                </form>
              )}
            </Formik>
          </React.Fragment>
        )}
        {data && systemConfig.systemType === 'delta' && (
          <React.Fragment>
            <Formik
              enableReinitialize
              initialValues={state.databaseObj}
              validationSchema={databasesSchema}
              onSubmit={async (values: any, { setSubmitting }) => {
                let obj = { ...values };

                let data: ISystemConfig = { ...systemConfig };
                data.databases[index] = obj;

                handleLoading();
                let result = await updateSystemConfig(data);
                handleLoading();

                if (result?.success) {
                  closeAddDialog(obj);
                  addUpdateValue(result.data);
                } else {
                  showToast(
                    result?.message ||
                      'Error while updating database configuration',
                    'error'
                  );
                }

                setState({
                  ...state,
                  databaseObj: {
                    datacenterName: '',
                    datacenterId: '',
                    name: '',
                    tables: [],
                  },
                  //   selectedDatacenters: [],
                });
                setSubmitting(false);
              }}>
              {({ handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div className='ms-Grid'>
                    <div className='ms-Grid-row'>
                      <div className='ms-Grid-col ms-xs12 ms-sm6'>
                        <CustomTextField
                          name={'name'}
                          placeholder={"Database's Name"}
                          disabled={!isOnEdit}
                        />
                      </div>
                      <div className='ms-Grid-col ms-xs12 ms-sm6'>
                        <CustomTextField name={'datacenterName'} disabled />
                      </div>
                    </div>
                    <div className='ms-Grid-row'>
                      <div className='ms-Grid-col ms-sm12'>
                        <div className='office-table'>
                          <table className='ms-Table w-100'>
                            <thead>
                              <tr>
                                <th>Floor Name</th>
                                <th>PDU Name</th>
                                <th>Table Name</th>
                              </tr>
                            </thead>
                            <tbody>
                              {state.isDataloaded &&
                                state.databaseObj.tables.map(
                                  (ele: any, indx: number) => {
                                    return (
                                      <tr key={indx}>
                                        {ele.index === 0 && (
                                          <td rowSpan={ele.length}>
                                            {ele.floorName}
                                          </td>
                                        )}
                                        <td>{ele.pduName}</td>
                                        <td>
                                          <CustomTextField
                                            name={`tables[${indx}].tableName`}
                                            disabled={!isOnEdit}
                                          />
                                        </td>
                                      </tr>
                                    );
                                  }
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Stack
                    horizontal
                    wrap
                    tokens={wrapStackTokens}
                    horizontalAlign='end'
                    className='pt-8'>
                    <DefaultButton
                      text='Cancel'
                      onClick={() => closeAddDialog()}
                    />
                    {isOnEdit && <PrimaryButton text='Update' type='submit' />}
                  </Stack>
                </form>
              )}
            </Formik>
          </React.Fragment>
        )} */}
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageDatabaseDialogEdit;
